export default __webpack_public_path__ + "static/media/ic-chevron-up.4d043c5e.svg";